<template>
	<div class="box">
		<div class="null-page" v-show="yes"></div>
		
		<div class="member-info" v-loading="loading" style="    border-radius: 13px;
    box-shadow: rgb(0 0 0 / 3%) 0px 4px 12px;">
			<el-tabs v-model="activeName"  @tab-click="handleClick">
				<el-tab-pane label="ข้อมูลพื้นฐาน" name="first" style="    font-family: 'sukhumvittadmai2' !important; ">
					<el-form ref="infoRef" :model="memberInfo" :rules="infoRules" label-width="110px">
						<el-form-item label="บัญชี" v-if="memberInfo.userName">
							<p style="padding-top: 7px; font-family: 'sukhumvittadmai' !important;">{{ memberInfo.userName }}</p>
						</el-form-item>
						<!-- <el-form-item label="ตู้จดหมาย">
							<p v-if="memberInfo.email">{{ memberInfo.email }}</p>
							<p v-else class="toBind" @click="$router.push({ path: '/member/security' })">ไปผูก</p>
						</el-form-item> -->
						<el-form-item label="เบอร์มือถือ">
							<p v-if="memberInfo.tell" style="padding-top: 6px; font-family: 'sukhumvittadmai' !important;">{{ memberInfo.tell }}</p>
							<p v-else class="toBind" @click="$router.push({ path: '/member/security' })" style="padding-top: 6px;  font-family: 'sukhumvittadmai' !important; ">ผูกเบอร์มือถือ</p>
						</el-form-item>
						<el-form-item label="ชื่อเล่น" prop="nickName"><el-input v-model="memberInfo.nickName"></el-input></el-form-item>
					</el-form>
					<div class="btn"><el-button size="medium" type="primary" @click="saveInfo" style="font-family: 'sukhumvittadmai2' !important;">บันทึก</el-button></div>
				</el-tab-pane>
				<el-tab-pane label="ภาพถ่ายอวาตาร์" name="second" style="    font-family: 'sukhumvittadmai2';">
					<div class="preview">
						<div class="title">ตัวอย่างอวาตาร์</div>
						<div class="content">
							ข้อมูลส่วนบุคคลที่สมบูรณ์ การอัปโหลดภาพอวาตาร์ช่วยให้คุณพบปะผู้คนได้มากขึ้น
							<br />
							ขนาดเริ่มต้นที่ดีที่สุดสําหรับอวตาร 120x120 px
						</div>
					</div>
					<el-upload :action="uploadActionUrl" :show-file-list="false" :on-success="handleAvatarSuccess" class="upload">
						<div class="img-wrap"><img :src="$img(memberInfo.userHeadImg)" @error="memberInfo.userHeadImg = defaultHeadImage" /></div>
					</el-upload>
					<div class="btn"><el-button size="medium" type="primary" @click="uploadHeadImg">บันทึก</el-button></div>
				</el-tab-pane>
			</el-tabs>
		</div>
	</div>
</template>

<script>
import { info, nickName, headImg } from '@/api/member/info';
import Config from '@/utils/config';
import { mapGetters } from 'vuex';
import { email } from '@/api/member/security';
export default {
	name: 'info',
	components: {},
	data: () => {
		return {
			memberInfo: {
				userHeadImg: '',
				userName: '', //บัญชี
				nickName: '', //ชื่อเล่น
				email: '',
				tell: ''
			},
			infoRules: {
				nickName: [{ required: true, message: 'กรุณาใส่ชื่อเล่น', trigger: 'blur' }, { max: 30, message: 'ความยาวสูงสุดคือ30อักขระ', trigger: 'blur' }]
			},
			activeName: 'first',
			loading: true,
			uploadActionUrl: Config.baseUrl + '/api/upload/headimg',
			imgUrl: '',
			yes: true
		};
	},
	created() {
		this.getInfo();
	},
	mounted() {
		let self = this;
		setTimeout(function() {
			self.yes = false
		}, 300)
	},
	methods: {
		getInfo() {
			info()
				.then(res => {
					if (res.code == 0) {
						this.memberInfo.userHeadImg = res.data.headimg;
						this.memberInfo.userName = res.data.username;
						this.memberInfo.nickName = res.data.nickname;
						this.memberInfo.email = res.data.email;
						this.memberInfo.tell = res.data.mobile;
					}
					this.loading = false;
				})
				.catch(err => {
					this.loading = false;
					this.$notify.error({title: 'Error',message: err.message});
				});
		},
		handleClick(tab, event) {},
		saveInfo() {
			this.$refs.infoRef.validate(valid => {
				if (valid) {
					nickName({ nickname: this.memberInfo.nickName })
						.then(res => {
							if (res.code == 0) {
								this.$notify({ message: 'การแก้ไขชื่อเล่นสําเร็จแล้ว', title: 'เรียบร้อยแล้ว',type: 'success' });
								this.getInfo;
								this.$store.dispatch('member/member_detail', { refresh: 1 });
							}
						})
						.catch(err => {
							this.$notify.error({title: 'Error',message: err.message});
						});
				} else {
					return false;
				}
			});
		},
		handleAvatarSuccess(res, file) {
			this.imgUrl = res.data.pic_path;
			this.memberInfo.userHeadImg = URL.createObjectURL(file.raw);
		},
		uploadHeadImg() {
			headImg({ headimg: this.imgUrl })
				.then(res => {
					if (res.code == 0) {
						this.$notify({ message: 'การปรับเปลี่ยนอวตารสําเร็จแล้ว', title: 'เรียบร้อยแล้ว',type: 'success' });
						this.$store.dispatch('member/member_detail', { refresh: 1 });
					}
				})
				.catch(err => {
					this.$notify.error({title: 'Error',message: err.message});
				});
		}
	},
	computed: {
		...mapGetters(['defaultHeadImage'])
	}
};
</script>
<style>
.member-info .el-upload {
	display: flex;
	justify-content: center;
	margin-bottom: 20px;
}
</style>
<style lang="scss" scoped>
.box {
	width: 100%;
	position: relative;
}

.null-page {
	width: 100%;
	height: 730px;
	background-color: #FFFFFF;
	position: absolute;
	top: 0;
	left: 0;
	z-index: 9;
}

.member-info {
	background: #ffffff;
	padding: 20px;
	.el-tab-pane {
		 font-family: 'sukhumvittadmai2';
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-content: center;
		.preview {
			display: flex;
			justify-content: center;
			margin-bottom: 20px;
			.title {
				margin-right: 20px;
				line-height: 3;
			}
			.content {
				  font-family: 'sukhumvittadmai2';
				color: $base-color;
				line-height: 1.5;
			}
		}
		.upload {
			display: flex;
			justify-content: center;
		}
		.el-upload {
			width: 120px;
		}
		.img-wrap {
			width: 120px;
			height: 120px;
			display: block;
			line-height: 120px;
			overflow: hidden;
			border: 1px solid #f1f1f1;
			cursor: pointer;
			img {
				display: inline-block;
			}
		}
		.el-form {
			margin-top: 20px;
			width: 500px;
			margin-left: 200px;
			.toBind {
				cursor: pointer;
				&:hover {
					color: $base-color;
				}
			}
		}
		.btn {
			text-align: center;
		}
	}
}.el-tabs--card > .el-tabs__header .el-tabs__nav {
    border: 1px solid #E4E7ED;
    border-bottom: none;
    
    box-sizing: border-box;
    border-radius: 10px 10px 0px 0px !important;
}.el-tabs__item {
   font-family: 'sukhumvittadmai2';
}.el-tabs__item.is-active {
   font-family: 'sukhumvittadmai2';
}
</style>
